export default "__VITE_ASSET__efd01f5f__"